import { render } from "./NewSideBar.vue?vue&type=template&id=1d781ead"
import script from "./NewSideBar.vue?vue&type=script&lang=js"
export * from "./NewSideBar.vue?vue&type=script&lang=js"

import "./NewSideBar.vue?vue&type=style&index=0&id=1d781ead&lang=css"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__